/* ==========================================================================
   Customer reviews — pagination and photo lightbox
   ========================================================================== */
(function () {
  'use strict';

  /* ------------------------------------------------- shared lightbox */
  var box = null;

  function lightbox() {
    if (box) return box;

    box = document.createElement('div');
    box.className = 'review-lightbox';
    box.setAttribute('aria-hidden', 'true');
    box.innerHTML =
      '<div class="review-lightbox__backdrop" data-review-close></div>' +
      '<button class="review-lightbox__close" type="button" data-review-close aria-label="Close">&times;</button>' +
      '<img class="review-lightbox__img" src="" alt="">';
    document.body.appendChild(box);

    box.querySelectorAll('[data-review-close]').forEach(function (el) {
      el.addEventListener('click', closeLightbox);
    });

    return box;
  }

  function openLightbox(src) {
    var el = lightbox();
    el.querySelector('.review-lightbox__img').src = src;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeLightbox() {
    if (!box) return;
    box.classList.remove('is-open');
    box.setAttribute('aria-hidden', 'true');
    box.querySelector('.review-lightbox__img').src = '';
    document.body.style.overflow = '';
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && box && box.classList.contains('is-open')) closeLightbox();
  });

  /* ------------------------------------------------- per-widget setup */
  function init(scope) {
    (scope || document).querySelectorAll('[data-reviews]').forEach(function (root) {
      if (root.dataset.kkReviewsReady === 'true') return;
      root.dataset.kkReviewsReady = 'true';

      // Photo lightbox
      root.querySelectorAll('[data-review-pic]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          openLightbox(btn.getAttribute('data-review-pic'));
        });
      });

      // Pagination
      var pager = root.querySelector('[data-reviews-pager]');
      if (!pager) return;

      var reviews = Array.prototype.slice.call(root.querySelectorAll('[data-review-page]'));
      var pageButtons = Array.prototype.slice.call(pager.querySelectorAll('[data-page]'));
      var prev = pager.querySelector('[data-page-prev]');
      var next = pager.querySelector('[data-page-next]');
      var list = root.querySelector('[data-reviews-list]');
      var total = pageButtons.length;
      var current = 1;

      function goTo(page, scroll) {
        current = Math.min(Math.max(page, 1), total);

        var first = true;
        reviews.forEach(function (r) {
          var onPage = parseInt(r.getAttribute('data-review-page'), 10) === current;
          r.hidden = !onPage;
          r.classList.toggle('is-first-on-page', onPage && first);
          if (onPage) first = false;
        });

        pageButtons.forEach(function (b) {
          var on = parseInt(b.getAttribute('data-page'), 10) === current;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-current', on ? 'true' : 'false');
        });

        if (prev) prev.disabled = current === 1;
        if (next) next.disabled = current === total;

        if (scroll && list) {
          var top = list.getBoundingClientRect().top + window.pageYOffset - 140;
          window.scrollTo({ top: top, behavior: 'smooth' });
        }
      }

      pageButtons.forEach(function (b) {
        b.addEventListener('click', function () {
          goTo(parseInt(b.getAttribute('data-page'), 10), true);
        });
      });

      if (prev) prev.addEventListener('click', function () { goTo(current - 1, true); });
      if (next) next.addEventListener('click', function () { goTo(current + 1, true); });

      goTo(1, false);
    });
  }

  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
